import "./PublishStatus.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button/Button";
import useUserData from "hooks/useUserData";
import { UserRoleIds } from "utils/userRoles";
import { getPublishStatusMeta } from "../../utils/constants";
import { UploadingStateType, useUploadInProgress } from "../../Uploading/hooks/useUploadInProgress";

const PublishStatus = ({ status, handleOpenDiscardModal, handleOpenPublishModal, changes, hasMissing, courseId }) => {
	const { uploadingState } = useUploadInProgress();
	const { label, icon, color, className } = getPublishStatusMeta(status);
	const { userData } = useUserData();
	const canPublish =
		userData.RoleId === UserRoleIds.ContentPublisher ||
		userData.RoleId === UserRoleIds.SystemAdmin;
	const isNewDraft = courseId < 0;

	return (
		<div className={`publish-status ${className}`} data-status-code={status}>
			<h1>Status</h1>
			<p className="publish-status__value">
				{icon && (
					<FontAwesomeIcon
						icon={icon}
						style={{ color, marginRight: 8 }}
						aria-hidden="true"
					/>
				)}
				<span>{label}</span>
			</p>
			<div className="publish-status-buttons">
				{!isNewDraft && (
					<Button text="Discard Current Changes" onClick={handleOpenDiscardModal} disabled={!changes.length} />
				)}
				<Button
					text="Publish"
					onClick={handleOpenPublishModal}
					disabled={!canPublish || !changes.length || hasMissing || uploadingState !== UploadingStateType.None}
				/>
			</div>
		</div>
	);
};

export default PublishStatus;
